module.exports = __webpack_public_path__ + "img/people300.png";